// Port seam for the OS hotkey registration (SCR-7069): the Tauri
// `dictation_set_hotkey` IPC lives app-side, so
// `src/composition/hosts/dictation/dictation-hotkey-wiring.ts` injects it at bootstrap. Fail-loud:
// a missing port would silently skip OS-level registration on save.

import type { DictationHotkeySettingsUpdate } from './useAuthenticatedDictateOnboardingHotkeyForm';

export interface DictationHotkeyPorts {
  /** Forward the chord to the OS hotkey layer; the app-side impl no-ops outside Tauri. */
  setDictationHotkey: (modifiers: string[], key: string | null) => Promise<void>;
  usePersistDictationHotkeys: () => (
    payload: DictationHotkeySettingsUpdate
  ) => Promise<unknown>;
  listenKeyCapture: (
    callback: DictationEventCallback<DictationKeyCapturePayload>
  ) => Promise<() => void>;
  listenChordCommitted: (callback: DictationEventCallback<void>) => Promise<() => void>;
  startKeyRecording: () => Promise<void>;
  stopKeyRecording: () => Promise<void>;
}

export interface DictationKeyCapturePayload {
  keyCode?: number;
  vkCode?: number;
  keyName?: string;
  modifiers?: Record<string, boolean>;
  isModifier?: boolean;
}

export interface DictationEvent<TPayload> {
  event: string;
  id: number;
  payload: TPayload;
}

export type DictationEventCallback<TPayload> = (event: DictationEvent<TPayload>) => void;

let ports: DictationHotkeyPorts | null = null;

export const configureDictationHotkeyPorts = (next: DictationHotkeyPorts): void => {
  ports = next;
};

export const getDictationHotkeyPorts = (): DictationHotkeyPorts => {
  if (!ports) {
    throw new Error(
      '[dictation/ui/onboarding/hotkey] ports not configured — the app must load ' +
        "'@/composition/hosts/dictation/dictation-hotkey-wiring' at bootstrap; tests must call " +
        'configureDictationHotkeyPorts() with a double first.'
    );
  }
  return ports;
};

export const resetDictationHotkeyPortsForTests = (): void => {
  ports = null;
};
